module.exports = __webpack_public_path__ + "static/media/school_image.2483f6b5.jpg";